/**
 * usePreInvoice - Hook para obtener una prefactura individual por ID
 * 
 * Utiliza React Query para gestionar el estado de carga, error y cache
 * de una prefactura específica obtenida por su ID desde la API.
 */

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { ViewPreInvoicesApiAdapter } from '../adapters/ViewPreInvoicesApiAdapter';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import type { PreInvoice } from '../models/ViewPreInvoices';

export const usePreInvoice = () => {
  const { preInvoiceId } = useParams<{ preInvoiceId: string }>();
  const preInvoiceIdNumber = parseInt(preInvoiceId || '0', 10);

  const preInvoicesAdapter = new ViewPreInvoicesApiAdapter(
    createHttpClient(apiClientWH)
  );

  const {
    data: preInvoice,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<PreInvoice>({
    queryKey: ['preInvoice', preInvoiceIdNumber],
    queryFn: () => preInvoicesAdapter.getPreInvoiceById(preInvoiceIdNumber),
    enabled: preInvoiceIdNumber > 0,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    preInvoice,
    isLoading,
    isFetching,
    error: error ? (error as Error).message : null,
    refetch,
  };
};

